import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, RotateCcw } from 'lucide-react';
import { Button } from './ui';

function BillingCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-dvh bg-app-bg py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-xl border border-app-border shadow-sm p-10 text-center">
          <XCircle className="w-12 h-12 text-orange-500 mx-auto mb-4" strokeWidth={1.75} />
          <h1 className="text-2xl font-semibold text-app-text mb-2">
            Payment cancelled
          </h1>
          <p className="text-app-text-muted mb-8">
            No charges were made. You can try again or head back to the app.
          </p>

          <div className="flex gap-3 justify-center">
            <Button variant="primary" size="md" onClick={() => navigate('/billing')}>
              <RotateCcw className="w-4 h-4" />
              Try again
            </Button>
            <Button variant="secondary" size="md" onClick={() => navigate('/runs')}>
              <ArrowLeft className="w-4 h-4" />
              Back to app
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BillingCancel;
